import { IconButton, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

const attributeData = [
    {
        attribute: "treated_date",
        name_th: "วันที่ป่วย",
        name_us: "Date Sick"
    }
]

function SpotmapContent(props) {
    const { data } = props;
    const [dataShow, setDataShow] = useState({});
    const [dataList, setDataList] = useState([]);

    useEffect(() => {
        // console.log(data);
        if (data !== undefined) {
            if (data.features !== undefined) {
                if (data.features.length === 1) {
                    setDataShow(data.features[0].values_.attributes);
                } else {
                    setDataList(data.features);
                }
            } else {
                setDataShow(data.attributes);
            }
        }
    }, [data]);

    // const mapDataSelected = useSelector(getMapDataSelected);


    // useEffect(() => {
    //     console.log(mapDataSelected.values_);
    // }, [mapDataSelected])

    return (
        <>
            {
                Object.keys(dataShow).length !== 0 ?
                    <Grid container spacing={0}>
                        <Grid xs={dataList.length > 1 ? 10 : 12 } sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <Typography variant="h5" className="mb-2 font-primary" sx={{
                                padding: 2,
                                paddingBottom: 0,
                                color: 'white'
                            }}>
                                {
                                    `เพศ ${dataShow.gender} อายุ ${dataShow.age} ปี`
                                }
                            </Typography>
                        </Grid>
                        <Grid xs={dataList.length > 1 ? 2 : 0 } sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <IconButton 
                                sx={{
                                    color: 'white',
                                    marginTop: '13px'
                                }}
                                onClick={(event) => {
                                    setDataShow({});
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid xs={12} sx={{
                            backgroundColor: 'rgb(62, 152, 211)',
                            marginBottom: 2
                        }}>
                            <Typography variant="h6" className="mb-2 font-primary" sx={{
                                fontWeight: 'normal',
                                paddingLeft: 2,
                                paddingRight: 2,
                                color: 'white'
                            }}>
                                {
                                    `ต.${dataShow.tambon_name} อ.${dataShow.amphur_name} จ.${dataShow.province_name}`
                                }
                            </Typography>
                        </Grid>
                        {
                            attributeData.map((attribute, index) => {
                                // console.log(data.attributes[attribute.attribute]);
                                // console.log(data[attribute.attribute])
                                // console.log(dayjs(data.attributes[attribute.attribute]).format("DD MMMM BBBB"))
                                return (
                                    <React.Fragment key={index}>
                                        <Grid xs={6}>
                                            <Typography variant='body1' className="font-primary" sx={{
                                                paddingLeft: 2
                                            }}>
                                                {attribute.name_th}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={6} sx={{
                                            paddingRight: 2
                                        }}>
                                            <Typography variant='body1' className="font-primary" sx={{
                                                textAlign: 'right'
                                            }}>
                                                {dayjs(data.attributes[attribute.attribute]).format("DD MMMM BBBB")}
                                            </Typography>
                                        </Grid>
                                    </React.Fragment>
                                )
                            })
                        }
                    </Grid> : 
                    <List sx={{ width: '100%' }}>
                        {
                            dataList.map((data, index) => {
                                return (
                                    <ListItemButton 
                                        key={index}
                                        onClick={(event) => {
                                            setDataShow(data.values_.attributes)
                                        }}
                                    >
                                        <ListItemText 
                                            primary={`เพศ ${data.values_.attributes.gender} อายุ ${data.values_.attributes.age} ปี`} 
                                            secondary={`ต.${data.values_.attributes.tambon_name} อ.${data.values_.attributes.amphur_name} จ.${data.values_.attributes.province_name}`}
                                        />
                                    </ListItemButton>
                                )
                            })
                        }
                    </List>
            }
        </>
    )
}

export default SpotmapContent
